import React, { useEffect, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "../OrderHistory.scss";
import { useAppContext } from "../../../../../Components/AppProvider";
import Modal from "../Modal/Modal";
import PaymentProcedure from "../Modal/ModalContent/PaymentProcedure";
import FullyPaid from "./ToPayStatus/FullyPaid";
import RateForm from "../Modal/ModalContent/RateForm/RateForm";

function CompleteOrderComponent() {
  const { completedOrderList, setOrderListUpdate } = useAppContext();

  const [expanded, setExpanded] = useState({});
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [singleOrderToPay, setSingleOrderToPay] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setOrderListUpdate(true);
  }, []);
  const toggleExpand = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  // ✅ Handle individual checkbox
  const handleSelectOrder = (id) => {
    setSelectedOrders((prev) => {
      let newSelected;
      if (prev.includes(id)) {
        newSelected = prev.filter((orderId) => orderId !== id);
      } else {
        newSelected = [...prev, id];
      }

      // auto-update "Select All"
      setSelectAll(newSelected.length === filteredOrders.length);
      return newSelected;
    });
  };

  // ✅ Handle "Select All"
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedOrders([]);
      setSelectAll(false);
    } else {
      const allIds = filteredOrders.map((order) => order.COI_ID);
      setSelectedOrders(allIds);
      setSelectAll(true);
    }
  };
  const filteredOrders = completedOrderList.filter((order) => {
    const keyword = searchTerm.toLowerCase();

    // 1️⃣ Build a raw string from all order fields
    const orderString = Object.values(order)
      .map((val) => (val ? String(val).toLowerCase() : ""))
      .join(" ");

    // 2️⃣ Compute status label and message based on your conditions
    let statusLabel = "";
    let message = "";

    if (order.COI_Status === "ToPayPartial") {
      statusLabel = "TO PAY";
      message = "AWAITING DOWNPAYMENT";
    } else if (order.COI_Status === "Partial" && order.COI_Downpayment == 0) {
      statusLabel = "PENDING";
      message = "Downpayment Proof Submitted – Awaiting Verification";
    } else if (order.COI_Status === "Partial" && order.COI_Downpayment > 0) {
      statusLabel = "PARTIALLY PAID";
      message =
        "Down payment received. Full payment will be requested once the item is ready to ship.";
    } else if (order.COI_Status === "ToPayFull") {
      statusLabel = "TO PAY (FULLY)";
      message =
        "Your order is now ready. Please settle the remaining balance to proceed with shipping.";
    } else if (order.COI_Status === "Fully" && order.COI_Balance > 0) {
      statusLabel = "PENDING";
      message = "Full Payment Proof Submitted – Awaiting Verification";
    } else if (order.COI_Status === "Fully" && order.COI_Balance == 0) {
      statusLabel = "FULLY PAID";
      message =
        "Full payment received. Your order is now being processed for shipment.";
    } else if (
      order.COI_Status === "PaymentDeclined" &&
      order.COI_PaymentType === "partial"
    ) {
      statusLabel = "DECLINED";
      message =
        "Your Downpayment was declined because the receipt uploaded was invalid.";
    } else if (
      order.COI_Status === "PaymentDeclined" &&
      order.COI_PaymentType === "full"
    ) {
      statusLabel = "DECLINED";
      message =
        "Your Full payment was declined because the receipt uploaded was invalid.";
    }

    const computedString = `${statusLabel} ${message}`.toLowerCase();

    // 3️⃣ Include in filter if keyword matches either raw or computed string
    return orderString.includes(keyword) || computedString.includes(keyword);
  });

  return (
    <>
      <div className="oh-dp-container">
        <div className="oh-dp-header">
          <div className="oh-dp-header-wrapper">COMPLETED ORDERS</div>
          <div className="oh-dp-button-wrapper ">
            <input
              type="text"
              placeholder="Search orders..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="oh-dp-downpayment">
          <div className="dp-action">
            {/** 
            <div className="selectall-wrapper">
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
              />
              <span>SELECT ALL</span>
            </div>*/}
            <div className="action-section">
              {selectedOrders.length > 0 && ( // ✅ show only if something is checked
                <button
                  className="btn-pay"
                  onClick={() => {
                    setSingleOrderToPay(null); // reset single order
                  }}
                >
                  PAY ({selectedOrders.length})
                </button>
              )}
            </div>
          </div>
          {filteredOrders.length > 0 ? (
            filteredOrders.map((order) => (
              <FullyPaid order={order} formatToMMDDYYYY={formatToMMDDYYYY} />
            ))
          ) : (
            <div className="no-orders-message">
              <p>No to received orders found.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default CompleteOrderComponent;
